import { LayoutGrid, BookOpen, Users, Activity, Building2, MessageSquare } from 'lucide-react';
import { AppSidebar, type NavGroup } from '@/components/AppSidebar';
import { useOrgInbox } from '@/lib/hooks/useMessages';

const ic = 'h-[18px] w-[18px]';

// /org must only match Dashboard exactly; other items match their own subtree.
const isActive = (to: string, pathname: string) =>
  pathname === to || (to !== '/org' && pathname.startsWith(to));

export function OrgSidebar() {
  const { data: threads = [] } = useOrgInbox();
  const needsReplyCount = threads.filter((t) => t.last_sender_id === t.student_id).length;

  const navGroups: NavGroup[] = [
    { label: 'Overview', items: [
      { to: '/org', label: 'Dashboard', icon: <LayoutGrid className={ic} /> },
      { to: '/org/messages', label: 'Messages', icon: <MessageSquare className={ic} />, badge: needsReplyCount },
    ] },
    { label: 'Learning', items: [
      { to: '/org/batches', label: 'Batches', icon: <BookOpen className={ic} /> },
      { to: '/org/students', label: 'Students', icon: <Users className={ic} /> },
    ] },
    { label: 'Placement', items: [
      { to: '/org/readiness', label: 'Placement Readiness', icon: <Activity className={ic} /> },
      { to: '/org/company-readiness', label: 'Company Readiness', icon: <Building2 className={ic} /> },
    ] },
  ];

  return (
    <AppSidebar
      navGroups={navGroups}
      storageKey="org-sidebar-collapsed"
      settingsPath="/org/settings"
      isActive={isActive}
    />
  );
}
